// extracted by mini-css-extract-plugin
export default {"-large":"s0Hn_6EsvicXieQxS6S8","greyBox":"qYnONqpiueKQ4A631k8x","visible":"M9m2M5YXQwo88oOuLpJ9","link":"cONJhaZLQrx1DbnJ1dAj"};